export const sortMessages = (list) =>
  [...list].sort((a, b) => {
    const ai = Number(a.id);
    const bi = Number(b.id);
    if (!Number.isNaN(ai) && !Number.isNaN(bi) && ai !== bi) {
      return ai - bi;
    }
    const ta = a.created_at ? new Date(a.created_at).getTime() : 0;
    const tb = b.created_at ? new Date(b.created_at).getTime() : 0;
    return ta - tb;
  });

export const findAssistantReply = (messages, questionMsg) => {
  if (!questionMsg) return null;
  const ordered = sortMessages(messages);
  const idx = ordered.findIndex((m) => m.id === questionMsg.id);
  if (idx !== -1) {
    for (let i = idx + 1; i < ordered.length; i += 1) {
      if (ordered[i].role === 'assistant') return ordered[i];
      if (ordered[i].role === 'user') break;
    }
  }
  const askerId = questionMsg.user?.id;
  const askedAt = questionMsg.created_at ? new Date(questionMsg.created_at).getTime() : 0;
  return ordered.find(
    (m) =>
      m.role === 'assistant' &&
      m.triggered_by?.id === askerId &&
      (!m.created_at || new Date(m.created_at).getTime() >= askedAt)
  );
};

export const staffKeyFromUser = (user) => {
  if (user?.id != null) return String(user.id);
  return 'unknown';
};

/** @param {Array} userQuestions - user-role messages, any order */
export const buildStaffSummaries = (userQuestions) => {
  const map = new Map();

  userQuestions.forEach((q) => {
    const key = staffKeyFromUser(q.user);
    if (!map.has(key)) {
      map.set(key, {
        key,
        user: q.user,
        questions: [],
        lastAt: 0,
      });
    }
    const entry = map.get(key);
    entry.questions.push(q);
    const t = q.created_at ? new Date(q.created_at).getTime() : 0;
    if (t > entry.lastAt) entry.lastAt = t;
  });

  return Array.from(map.values())
    .map((entry) => ({
      ...entry,
      questions: [...entry.questions].sort((a, b) => {
        const ta = a.created_at ? new Date(a.created_at).getTime() : 0;
        const tb = b.created_at ? new Date(b.created_at).getTime() : 0;
        return tb - ta;
      }),
    }))
    .sort((a, b) => b.lastAt - a.lastAt);
};
